import { useCallback } from "react"
import { useGianoDisconnect } from "./use-giano-disconnect"

export const useLogout = () => {
    const { disconnect } = useGianoDisconnect()

    const handleLogout = useCallback(() => {
        return disconnect()
    }, [disconnect])

    return { logout: handleLogout }
}